import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { loadRules, saveRules, DEFAULT_RULES, RuleSet } from "@/lib/rules";

const Admin = () => {
  const [rules, setRules] = useState<RuleSet>(() => loadRules());
  const [json, setJson] = useState<string>("");

  useEffect(() => {
    setJson(JSON.stringify(rules, null, 2));
  }, [rules]);

  const onSave = () => {
    try {
      const parsed = JSON.parse(json) as RuleSet;
      saveRules(parsed);
      setRules(parsed);
      toast.success("Kurallar kaydedildi (local)");
    } catch (e) {
      toast.error("JSON hatalı. Lütfen kontrol edin.");
    }
  };

  const reset = () => {
    setRules(DEFAULT_RULES);
    setJson(JSON.stringify(DEFAULT_RULES, null, 2));
    saveRules(DEFAULT_RULES);
    toast("Varsayılana döndü");
  };

  return (
    <main className="min-h-screen w-full px-4 py-8 mx-auto max-w-5xl space-y-6">
      <header className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Admin Panel · Transfer Kuralları</h1>
        <div className="flex gap-2">
          <Button variant="secondary" onClick={reset}>Varsayılan</Button>
          <Button onClick={onSave}>Kaydet</Button>
        </div>
      </header>

      <section className="grid md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Hızlı Alanlar</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="text-sm">Para Birimi</label>
                <Input value={rules.currency} onChange={(e)=>setRules({...rules, currency:e.target.value})} />
              </div>
              <div>
                <label className="text-sm">Dönüş İndirimi (%)</label>
                <Input type="number" value={rules.returnDiscountPercent}
                  onChange={(e)=>setRules({...rules, returnDiscountPercent:Number(e.target.value)})} />
              </div>
            </div>
            <p className="text-sm text-muted-foreground">Detay düzenleme için JSON'u kullanın.</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>JSON Rule Set</CardTitle>
          </CardHeader>
          <CardContent>
            <Textarea className="font-mono min-h-[420px]" value={json} onChange={(e)=>setJson(e.target.value)} />
          </CardContent>
        </Card>
      </section>

      <Card>
        <CardHeader>
          <CardTitle>Özet</CardTitle>
        </CardHeader>
        <CardContent>
          <pre className="text-sm whitespace-pre-wrap">{json}</pre>
        </CardContent>
      </Card>
    </main>
  );
};

export default Admin;
